import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    eventName: '',
};

export const eventsSlice = createSlice({
    name: "events",
    initialState,
    reducers: {
        setEventName: (state, { payload }) => {
            state.eventName = payload;
            return state;
        }
    },
});

export const { setEventName } = eventsSlice.actions;

export default eventsSlice.reducer;
